import { action, makeObservable, observable } from 'mobx';
import { userInfoStore, roundInfoStore, notificationStore } from '@pascal/pascal-core';
import { freeBetStore, gameConfigStore } from '@pascal/pascal-core/shared/core/store';

import { gameLiveConnection, soundService } from '../services';
import { checkDoBetModel } from '../helpers/supporters';

class DoBetStore {
  winAmount = 0;

  isLoadingBetButton = false;

  totalBetsAmount = 0;

  betInfoThisMoment = {};

  rangeValues = [];

  betData = {
    betId: null,
    amount: gameConfigStore.limits.minBet || 0,
    isBetAccepted: false,
    winAmount: null,
    isDisabled: false,
    freeBetId: null,
  };

  constructor() {
    makeObservable(this, {
      winAmount: observable,
      betData: observable.deep,
      totalBetsAmount: observable,
      rangeValues: observable.deep,
      isLoadingBetButton: observable,
      betInfoThisMoment: observable.deep,
      doBetSender: action.bound,
      setBetAmount: action.bound,
      setWinAmount: action.bound,
      setRangeValues: action.bound,
      resetGameStates: action.bound,
      handleDoBetResult: action.bound,
      updateBetAccepted: action.bound,
      // decreaseDemoBalance: action.bound,
      // increaseDemoBalance: action.bound,
      updateInitialBetData: action.bound,
      setBetInfoThisMoment: action.bound,
      updateTotalBetsAmount: action.bound,
      setIsLoadingBetButton: action.bound,
      updateIsDisabledBetSection: action.bound,
    });
  }

  setRangeValues(rangeValues) {
    this.rangeValues = rangeValues;
  }

  updateTotalBetsAmount(amount, isReset = false) {
    if (isReset) {
      this.totalBetsAmount = 0;
    } else {
      this.totalBetsAmount += Number(amount);
    }
  }

  setBetInfoThisMoment(data) {
    this.betInfoThisMoment = data;
  }

  updateBetAccepted(isBetAccepted, betId) {
    this.betData = {
      ...this.betData,
      isBetAccepted,
      betId,
    };
  }

  setIsLoadingBetButton(isLoadingBetButton) {
    this.isLoadingBetButton = isLoadingBetButton;
  }

  setBetAmount(amount) {
    this.betData = { ...this.betData, amount };
  }

  updateIsDisabledBetSection(isDisabledBetSection) {
    this.betData = {
      ...this.betData,
      isDisabled: isDisabledBetSection,
    };
  }

  setWinAmount(winAmount) {
    this.winAmount = winAmount;
    if (winAmount) {
      setTimeout(() => gameLiveConnection.getBalance(), 900);
    }
  }

  // increaseDemoBalance(amount, odd) {
  //   const balance = userInfoStore.balance + amount * odd;
  //   userInfoStore.setDemoBalance(balance);
  // }

  // decreaseDemoBalance(betAmount) {
  //   userInfoStore.setDemoBalance(userInfoStore.balance - betAmount);
  // }

  resetGameStates() {
    this.betData = {
      betId: null,
      amount: gameConfigStore.limits.defaultBetAmount || gameConfigStore.limits.minBet || 0,
      isBetAccepted: false,
      winAmount: null,
      isDisabled: false,
      freeBetId: null,
    };
    this.isLoadingBetButton = false;
    this.setWinAmount('');
    this.updateTotalBetsAmount(0, true);
    notificationStore.setNotificationType(null);
  }

  updateInitialBetData(data) {
    this.betData = data;
  }

  doBetSender() {
    const { amount } = this.betData;
    const { roundId } = roundInfoStore;
    const { limits } = gameConfigStore;
    // const { isDemo } = applicationStore;
    const { balance: userBalance } = userInfoStore;
    const {
      activeFreeBet: { id, amount: freeBetAmount },
    } = freeBetStore;

    const responseCode = checkDoBetModel(limits, userBalance, amount);

    this.setIsLoadingBetButton(true);
    if (responseCode) {
      notificationStore.setNotificationType({
        responseCode,
      });

      // if (isDemo) {
      this.setIsLoadingBetButton(false);
      // }
      this.updateIsDisabledBetSection(false);
    } else {
      const rangeData = this.rangeValues.map((item) => ({ from: item.from, to: item.to }));
      const doBetModel = {
        amount,
        roundId,
        betData: rangeData,
      };

      // if (isDemo) {
      //   const currentDemoBetData = {
      //     ...doBetModel,
      //     status: BetStatus.Pending,
      //     id: createGuid(),
      //     odd: this.betInfoThisMoment.odd,
      //     date: new Date(),
      //     responseCode: BetResponseCode.Success,
      //   };
      //   if (currentDemoBetData.amount <= userInfoStore.balance) {
      //     this.decreaseDemoBalance(amount);
      //     this.updateTotalBetsAmount(amount);
      //     this.handleDoBetResult(currentDemoBetData);
      //     popupStore.updateDemoBetsCount();
      //   }
      // } else {
      if (id) {
        doBetModel.freeBetId = id;
        doBetModel.amount = freeBetAmount;
      }
      gameLiveConnection.doBet(doBetModel);
    }
    // }
  }

  handleDoBetResult(doBetData) {
    const { responseCode } = doBetData;

    soundService.playBetAccepted();
    // betStore.updateLiveBets(doBetData);

    this.setIsLoadingBetButton(false);
    notificationStore.setNotificationType({ responseCode });
  }
}

export const doBetStore = new DoBetStore();
